import { useUnit } from 'effector-react'
import { $detailsByGateway, $loadingGatewayIds, $pageByGateway } from './model'

export const useGatewayDetails = (gatewayId: number) => {
  const [detailsByGateway, pageByGateway, loadingGatewayIds] = useUnit([
    $detailsByGateway,
    $pageByGateway,
    $loadingGatewayIds,
  ])

  return {
    items: detailsByGateway[gatewayId]?.items ?? [],
    total: detailsByGateway[gatewayId]?.total ?? 0,
    page: pageByGateway[gatewayId] ?? 1,
    loading: loadingGatewayIds.includes(gatewayId),
  }
}
